
export default {
  // Auth-related translations
  "sign_in": "Sign In",
  "sign_up": "Sign Up",
  "email_address": "Email Address",
  "password": "Password",
  "forgot_password": "Forgot Password?",
  "magic_link_sent": "Magic link sent to your email",
  "magic_link_error": "Failed to send magic link. Please try again later.",
  "send_magic_link": "Send Magic Link",
  "processing": "Processing...",
  "back": "Back",
  "leave_page_warning": "You have unsaved changes. Are you sure you want to leave this page?",
  "wait_before_retry": "Wait before retrying",
  "reset_rate_limit_message": "Please wait {{seconds}} seconds before requesting another link.",
  "reset_rate_limit_exceeded": "Email rate limit exceeded. Please wait before trying again.",
  "sign_in_success": "Successfully signed in!",
  "sign_in_failed": "Failed to sign in",
  "completing_sign_in": "Completing sign in...",
  "please_wait": "Please wait while we verify your credentials.",
  "or_continue_with": "Or continue with",
  "or_with_email": "Or with email",
  "continue_with_google": "Continue with Google",
  "dont_have_account": "Don't have an account?",
  "already_have_account": "Already have an account?",
  "email_delivery_not_configured": "Email delivery is not configured. Please contact the administrator.",
  "for_testing_use": "For development testing, you can use Supabase CLI or Dashboard to manage users",
  
  // Username dialog related translations
  "create_username": "Create Username",
  "username_required_description": "Please create a username to continue. Your username will be visible to other users.",
  "username": "Username",
  "username_placeholder": "Enter a username",
  "username_requirements": "Username can only contain letters, numbers and underscores.",
  "save_username": "Save Username",
  "username_taken": "This username is already taken. Please try another one.",
  "username_set_success": "Username has been set successfully!",
  "username_set_error": "Failed to set username. Please try again.",
  "auth_error": "Authentication error. Please try signing in again."
};
